import React from 'react';
import RecentDonationsTable from '../components/recentDonationsTable';
import Banner from '../components/banner';
import ErrorComponent from '../components/partnerError';
import moment from 'moment';

import {
	Table,
	Button,
	Loader,
	Form,
	FormField,
	FormRow,
	Input,
	Glyph,
	Card,
	Spinner
} from 'kepler';

import {
	DateRanger
} from 'ppgf-components';

const activityData = $('body').data();
var notLoading = true;

const ErrorMsgs = {
	oneFieldErr: 'Either donor name or start date is required.',
	donorLengthErr: 'Donor name too short.'
}

export default class RecentDonations extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			loader: false,
			pageNo: activityData.body.pageNo,
			npid: activityData.body.npid,
			transactions: activityData.body.transactions,
			charityName: activityData.body.charityName,
			donorName: '',
			startDate: '',
			endDate: '',
			errorType: activityData.body.errorType,
			invoiceItemDataList: '',
			rowInx: '',
			csrf: $('body').attr('data-csrf') || '',
			errorKey: ''
		};
		this.formSubmit = this.formSubmit.bind(this);
		this.updateFromDate = this.updateFromDate.bind(this);
		this.updateEndDate = this.updateEndDate.bind(this);
		this.setDonorName = this.setDonorName.bind(this);
		this.downloadCSVfile = this.downloadCSVfile.bind(this);
		this.validateAndbuildParams = this.validateAndbuildParams.bind(this);
	}

	updateFromDate(startDate) {
		this.setState({
			startDate: startDate
		});
	}

	updateEndDate(endDate) {
		this.setState({
			endDate: endDate
		});
	}

	downloadCSVfile() {
		const self = this;
		$('.errorField').addClass('hide');

		let {
			startDate: fromDate,
			endDate: toDate,
			donorName
		} = self.state;

		if (fromDate.toString().trim().length) {
			fromDate = moment(fromDate).format('YYYY/MM/DD').replace(/\//gi, '');
			toDate = moment(toDate).format('YYYY/MM/DD').replace(/\//gi, '');
		} else {
			fromDate = '';
			toDate = '';
		}

		location.href = '/givingfund/partner/recentdonations.csv?donorName=' + donorName + '&fromDate=' + fromDate + '&toDate=' + toDate;
	}

	validateAndbuildParams() {
		const self = this;
		let {
			startDate: fromDate,
			endDate: toDate,
			donorName
		} = self.state;

		if (donorName.toString().trim().length == 0 && fromDate.toString().trim().length === 0) {		
			return 'oneFieldErr';
		}

		if (donorName && donorName.length < 3) {
			return 'donorLengthErr';
		}
		return true;	
	}

	formSubmit(e) {
		const self = this;
		$('.errorField').addClass('hide');
		let errorKey = self.validateAndbuildParams();

		if (errorKey.length) {
			self.setState({
				errorKey: errorKey
			},()=>{
				$('.errorField').removeClass('hide');
				return;
			});
			return;
		}

		self.setState({
			loader: true,
			transactions: []
		});


		let {
			startDate: fromDate,
			endDate: toDate,
			donorName
		} = self.state;

		if (fromDate.toString().trim().length) {
			fromDate = moment(fromDate).format('YYYY/MM/DD').replace(/\//gi, '');
			toDate = moment(toDate).format('YYYY/MM/DD').replace(/\//gi, '');
		} else {
			fromDate = '';
			toDate = '';
		}

		$.post(
			'/givingfund/partner/recentdonations/results', {
				donorName: donorName,
				fromDate: fromDate,
				toDate: toDate,
				pageNo: 1,
				npid: activityData.body.npid,
				charityName: activityData.body.charityName,
				_csrf: self.state.csrf
			},
			result => {
				if (result.redirectUrl) {
					window.location.href = result.redirectUrl;
				} else {
					self.setState({
						loader: false,
						transactions: result.transactions,
						pageNo: result.pageNo
					});
				}
			}
		);
	}

	startLoadingMoreTransactions() {
		const self = this;
		let csrf = $('body').attr('data-csrf');
		notLoading = false;
		const params = {};

		let {
			startDate: fromDate,
			endDate: toDate,
			donorName
		} = self.state;

		if (fromDate.toString().trim().length) {
			fromDate = moment(fromDate).format('YYYY/MM/DD').replace(/\//gi, '');
			toDate = moment(toDate).format('YYYY/MM/DD').replace(/\//gi, '');
		} else {
			fromDate = '';
			toDate = '';
		}

		if (this.state.transactions && this.state.transactions.length) {
			$.post(
				'/givingfund/partner/recentdonations/results',
				{
					_csrf: csrf,
					pageNo: parseInt(self.state.pageNo) + 1,
					donorName: donorName,
					fromDate: fromDate,
					toDate: toDate,
					npid: activityData.body.npid,
					charityName: activityData.body.charityName
				},
				result => {
					if (result.redirectUrl) {
						$('#loadmorespinner').hide();
						window.location.href = result.redirectUrl;
					} else {
						$('#loadmorespinner').hide();
						notLoading = true;
						self.setState({
							transactions: result.transactions,
							pageNo: result.pageNo
						});
					}
				}
			);
		} else {
			$('#loadmorespinner').hide();
		}
	}

	setDonorName(value, event) {
		this.setState({
			donorName:value
		})
	}

	componentDidMount() {
		const self = this;
		let csrf = $('body').attr('data-csrf');
		$(window).on('scroll', function() {
			if ($('#recentDonationsTable').is(':visible')) {
				let $elem = $('#recentDonationsTable'),
					$window = $(window),
					docViewTop = $window.scrollTop(),
					docViewBottom = docViewTop + $window.height(),
					elemTop = $elem.offset().top,
					elemBottom = elemTop + $elem.height();
				if (elemBottom < docViewBottom && notLoading) {
					$('#loadmorespinner').show();
					self.startLoadingMoreTransactions();
					notLoading = false;
				}
			}
		});

		/*
		 ** Toggle Invoice details - Item ID and Receiver Transaction ID
		 */
		$('#recentDonationsTable').on('click', 'tr.activityRow', function() {
			$('.icon-arrow-down-small', this).toggleClass(
				'icon-arrow-up-small'
			);
			$(this)
				.next()
				.toggle();
			return false;
		});

		$('#recentDonationsTable').on('click', 'tr.invoiceAvailable', function() {
				const clickedClassName = this.className,
					rowInx = $('tr.invoiceAvailable').index(this),
					toggle = $(this).next('.transSubDetails')
					.is(':visible');
				//Check if AJAX Response already loaded
				if (clickedClassName.indexOf('loadedResponse') > 0) {
					$('.icon-arrow-down-small', this).toggleClass('icon-arrow-up-small');
					$(this).next('.transSubDetails').toggle();
				} else {
					if (!toggle) {
						self.setState({
							loader: true
						});
						$.post(
							'/givingfund/partner/getInvoiceDetails', {
								accountNo: $(this)
									.find('span.accountNo')
									.text(),
								invoiceId: $(this)
									.find('span.invoiceId')
									.text(),
								_csrf: csrf
							},
							result => {
								$(this).next('.transSubDetails').toggle();
								$('.icon-arrow-down-small', this).toggleClass('icon-arrow-up-small');
								if (result.status == 'success') {
									$(this).addClass('loadedResponse');
									$('#loadmorespinner').hide();
									self.setState({
										loader: false,
										invoiceItemDataList: result.invoiceItemDataList,
										rowInx: rowInx
									});
								} else {
									console.log(result);
								}
							}
						);
					} else {
						$(this)
							.toggleClass('selected')
							.next('.transSubDetails')
							.toggle();
					}
				}
			}
		);
	}

	render() {
		const error = this.state.errorType;

		if (!error) {
			return (
				<div>
					<Banner charityName={this.state.charityName} pageName={activityData.body.pageName}/>
					<div className="container">
						<Card id="recentDonationsWrapper">
							<h2 className="activityHeader">Recent Donations</h2>

							<div className="alertWrapper">
								<div className="vx_alert vx_alert-critical errorField hide">
									<p className="vx_alert-text">
										{ErrorMsgs[this.state.errorKey]}
									</p>
								</div>
							</div>

							<Form type="inline">
								<FormRow>
									<FormField
										width="one-quarter"
										htmlFor="donor-name"
										className="donorName"
									>
										<Input
											placeholder="Donor Name"
											label="Donor Name"											
											name="donor-name"
											size="sm"
											onChange={this.setDonorName}
											value={this.state.donorName}
										/>
									</FormField>
									<FormField
										width="one-fifths"
										className="datePickFormField"
									>
										<div>
											<DateRanger
												updateFromDate={this.updateFromDate} 
												updateEndDate={this.updateEndDate}
											 />
										</div>
									</FormField>
									<FormField offsetAbsentLabel>
										<Button
											className="filterButton"
											size="md"
											onClick={(e) => this.formSubmit('filter')}
										>
											Filter
										</Button>
									</FormField>
									<FormField offsetAbsentLabel>
										<Button
											className="filterButton"
											type="secondary"
											size="md"
											onClick={ (e) => this.downloadCSVfile() } 
										>
											Download CSV
										</Button>
									</FormField>
								</FormRow>
							</Form>
							<RecentDonationsTable
								transactions={this.state.transactions}
								pageNo={this.state.pageNo}
								invoiceItemDataList={
									this.state.invoiceItemDataList
								}
								rowInx={this.state.rowInx}
							/>
							<Loader
								show={this.state.loader}
								priority={10}
								type="fixed"
								size="lg"
								opacity={0.5}
							/>
							<Loader
								show={true}
								priority={9}
								size="md"
								opacity={0.5}
								id="loadmorespinner"
							>
								Loading...
							</Loader>
						</Card>
					</div>
				</div>
			);

		} else {
			return (<div><ErrorComponent errorType={error}/></div>);
		}
	}
}



// WEBPACK FOOTER //
// ./partner/components/recentdonations.js